import { render } from "./B2bTableServiciosEmpresas.vue?vue&type=template&id=30f4d7d2&scoped=true&lang=pug"
import script from "./B2bTableServiciosEmpresas.vue?vue&type=script&lang=js"
export * from "./B2bTableServiciosEmpresas.vue?vue&type=script&lang=js"

import "./B2bTableServiciosEmpresas.vue?vue&type=style&index=0&id=30f4d7d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f4d7d2"]])

export default __exports__